import Glide from '@glidejs/glide';

export const PXHistoryTimeline = (function () {
	'use strict';

	let sliders;

	function init() {
		sliders = document.querySelectorAll('.pxblock--history-timeline');

		if (sliders.length === 0) return;

		sliders.forEach((s) => {
			let timeline = s.querySelector('.timeline');
			let sliderNavButtons = s.querySelectorAll('button.slider__arrow');
			let timelineEvents = s.querySelectorAll('.timeline__event');
			let selectEl = s.querySelector('.polyselect select');
			let dateSpans = s.querySelectorAll('.formatted-datetime');

			if (timelineEvents.length === 0) return;

			move_to_event(timelineEvents.item(0), timeline);

			let g = new Glide(s.querySelector('.glide'), {
				type: 'slider',
			}).mount();

			g.on('run', (move) => {
				timelineEvents.forEach((el, k) => {
					el.classList.remove('active');
					el.removeAttribute('aria-current');
					if (k === g.index) {
						el.classList.add('active');
						el.setAttribute('aria-current', 'true');

						move_to_event(el, timeline);
					}
				});
			});

			// set aria hidden & tabindex
			g.on('move.after', (e) => {
				let slideItem  = $(s).find('.glide__slide'),
				    currentBtn = $('.timeline').children('.active'),
						nxtBtns    = currentBtn.next().next().nextAll('button'),
						prevBtns   = currentBtn.prev().prev().prevAll('button')

				$('button.timeline__event').removeAttr('aria-hidden')
				$('button.timeline__event').removeAttr('tabindex')
				
				nxtBtns.attr('aria-hidden', 'true')
				nxtBtns.attr('tabindex', '-1')

				prevBtns.attr('aria-hidden', 'true')
				prevBtns.attr('tabindex', '-1')

				$.each(slideItem, function (i, val) { 
					let item = $(val)

					item.removeAttr('aria-hidden')
					item.removeAttr('tabindex')

					if (!item.hasClass('glide__slide--active')) {
						item.attr('aria-hidden', 'true')
						item.attr('tabindex', '-1')
					}
				})
			})			

			timelineEvents.forEach((el, k) => {
				el.addEventListener('click', (ev) => {
					el.classList.add('active');
					g.go('=' + k);
				});
			});

			sliderNavButtons.forEach((b) => {
				b.addEventListener('click', function (ev) {
					let dir = this.classList.contains('prev') ? '<' : '>';
					g.go(dir);
				});
			});

			selectEl.addEventListener('change', (ev) => {
				// items.some(function(el, i) {
				// 		if (el.name == paramProgramName) {
				// 				index = i;
				// 				return true; 
				// 		}
				// });

				let firstEventInYearIndex
				Array.from(timelineEvents).forEach(function(el, i) {
					if (el.dataset.year === selectEl.value) {
						firstEventInYearIndex = i
					}
				})

				if (firstEventInYearIndex !== -1) g.go(`=${firstEventInYearIndex}`);
			});

			dateSpans.forEach((s) => {
				const event = new Date(s.dataset.date);
				const options = { weekday: undefined, year: 'numeric', month: 'long', day: undefined };

				s.innerText = event.toLocaleDateString(s.dataset.lang.replace('_', '-'), options);
			});
		});
	}

	function move_to_event(ev, timeline) {
		let eventRect = ev.getBoundingClientRect();
		let timelineRect = timeline.getBoundingClientRect();

		// The `+ 10` offsets the positioning by half the width (20px)
		// of the event circle, centering it.
		let eventPercentageFromLeft = ((eventRect.left - timelineRect.left + 10) / timelineRect.width) * 100;

		timeline.style.transform = 'translateX(-' + eventPercentageFromLeft + '%)';
	}

	return {
		init: init,
	};
})();
